import { Box, Skeleton, Stack } from "@mui/material";

/**
 * Loading placeholders. Use during initial fetch instead of CircularProgress —
 * the page chrome stays visible, which feels faster and less startling.
 */

export function TableRowSkeleton({ columns = 4 }) {
  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        px: 2,
        py: 1.5,
        borderBottom: 1,
        borderColor: "divider",
        alignItems: "center",
      }}
    >
      {Array.from({ length: columns }).map((_, idx) => (
        <Skeleton
          key={idx}
          variant="text"
          sx={{ flex: idx === 0 ? 2 : 1, fontSize: "0.95rem" }}
        />
      ))}
    </Stack>
  );
}

export function TableSkeleton({ rows = 6, columns = 4 }) {
  return (
    <Box>
      {Array.from({ length: rows }).map((_, idx) => (
        <TableRowSkeleton key={idx} columns={columns} />
      ))}
    </Box>
  );
}

export function CardSkeleton({ height = 96 }) {
  return (
    <Box
      sx={{
        p: 2,
        borderBottom: 1,
        borderColor: "divider",
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Skeleton variant="circular" width={40} height={40} />
        <Stack spacing={0.75} sx={{ flex: 1 }}>
          <Skeleton variant="text" width="60%" />
          <Skeleton variant="text" width="40%" />
        </Stack>
      </Stack>
      {height > 56 && (
        <Skeleton
          variant="rectangular"
          sx={{ mt: 1.5, borderRadius: 1, height: Math.max(0, height - 56) }}
        />
      )}
    </Box>
  );
}

export function ListSkeleton({ rows = 5 }) {
  return (
    <Box>
      {Array.from({ length: rows }).map((_, idx) => (
        <CardSkeleton key={idx} height={72} />
      ))}
    </Box>
  );
}
